'use strict';
import {runInjector} from '../_libs/angular-utils/index';
import {I18nComponent} from './react-i18n/I18nComponent';
import {fileDialogModule} from './file-dialog';
import {reactModalsModule} from './react-modals';
import {reactReduxModalsModule} from './react-redux-modals/module';
import {reactUtilsModule} from './react-utils/module';
import {reduxObservableListExportsModule} from './redux-observable-list-exports/module';
import './react-modals/ModalManager';


const angular = require('angular');

module.exports = angular
  .module('app.core-utilities', [
    require('./angular-rx-attrs').name,
    require('./aws-api').name,
    require('./countUp').name,
    require('./csv-imports-exports').name,
    require('./device-services').name,
    require('./domain').name,
    require('./dynamic-header-buttons').name,
    require('./fetch-utils').name,
    fileDialogModule.name,
    require('./filters').name,
    require('./firebaseLogger').name,
    require('./gallery-utilities').name,
    require('./geo').name,
    require('./maps-api').name,
    require('./misc-utils').name,
    require('./ng-repeat-utils').name,
    require('./notifications').name,
    require('./papaParse').name,
    reactModalsModule.name,
    require('./responsive-components').name,
    reactReduxModalsModule.name,
    reactUtilsModule.name,
    reduxObservableListExportsModule.name,
    require('./safeApply-operator').name,
    require('./transformer-directive').name,
    require('./upload-service').name,
    require('./wizards').name,
  ])
  .factory('HashMap', require('./angularApiExtensions.js'))
  .run(runInjector(I18nComponent))
;



// WEBPACK FOOTER //
// ./src/js/core-utilities/index.js